export enum BlobUploadCategory {
    User,
    Order,
    Product
}